import React from 'react';
import  { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import 'react-circular-progressbar/dist/styles.css';
import './index.css'; 
import AppRouter from './main';
import './i18n'; 
const root = createRoot(document.getElementById('root'));

root.render(<AppRouter />);